/**
 * @deprecated
 * Use the "withTeam" HOC on domain\team\team.hocs.ts
 */
const mapTeamToProps = state => ({
    team: state.team.data,
});

export default mapTeamToProps;
